import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDate = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.5 3.05176e-05C3.77614 3.05176e-05 4 0.223888 4 0.500031V1.00003H12V0.500031C12 0.223888 12.2239 3.05176e-05 12.5 3.05176e-05C12.7761 3.05176e-05 13 0.223888 13 0.500031V1.00003H14C15.1046 1.00003 16 1.89546 16 3.00003V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V3.00003C0 1.89546 0.895431 1.00003 2 1.00003H3V0.500031C3 0.223888 3.22386 3.05176e-05 3.5 3.05176e-05ZM1 4.00003V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V4.00003H1Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgDate);
export { ForwardRef as ReactComponent };
